import joi from 'joi'

export const nameSchema = joi.string().min(2).max(100).lowercase().required()
export const emailSchema = joi.string().email({ tlds: {allow: false} }).lowercase().required()
export const passwordSchema = joi.string().min(3).max(30).required()
export const repasswordSchema = joi.string().min(3).max(30).required()

